/**
 * Pilates & Yoga - Financial Report Page
 * Comprehensive financial analysis for studios
 */

import { useEffect } from 'react';
import { ServiceFinancialReport } from '@/components/industry/reports';
import { useIndustryServices, useIndustryAppointments } from '@/hooks/industry';
import { CompanyType } from '@/types/company';
import { MainLayout } from "@/components/MainLayout";

export default function PilatesYogaFinancialPage() {
  useEffect(() => {
    document.title = 'Relatório Financeiro | Controle Financeiro';
  }, []);

  const { services, isLoading: loadingServices } = useIndustryServices({
    domain: CompanyType.PILATES_YOGA,
  });

  const { appointments, isLoading: loadingAppointments } = useIndustryAppointments({
    domain: CompanyType.PILATES_YOGA,
  });

  if (loadingServices || loadingAppointments) {
    return (
<MainLayout>
      <div className="container mx-auto py-6">
        <div className="flex items-center justify-center py-12">
          <div className="text-muted-foreground">Carregando relatório...</div>
        </div>
      </div>
    
    </MainLayout>);
  }

  return (
<MainLayout>
    <div className="container mx-auto py-6">
      <ServiceFinancialReport
        services={services || []}
        appointments={appointments || []}
      />
    </div>
  
    </MainLayout>);
}

